<template>
  <q-page class="order-view-layout">
    <order-stepper v-if="!loading" />

    <div class="content-wrap row justify-center">
      <div class="container full-width">
        <div
          v-if="loading"
          class="preloader column justify-center items-center full-height ws-typography"
        >
          <ws-spinner class="q-mb-xl" />
          <span>
            {{ $t('general.cary_loading.top_line') }}
            <br />
            {{ $t('general.cary_loading.bottom_line') }}
          </span>
        </div>
        <router-view v-else />
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { QPage, QSkeleton } from 'quasar';
import { mapState } from 'vuex';
import { Theme } from '@odin/services';
import { WsSpinner } from '@odin/components-vue2';

import { type CartExtended } from '@/store/const';

import OrderStepper from '@/components/OrderStepper.vue';

@Component({
  components: {
    WsSpinner,
    QPage,
    QSkeleton,
    OrderStepper,
  },
  computed: {
    ...mapState(['cart']),
  },
})
export default class OrderLayout extends Vue {
  readonly cart!: CartExtended;
  Theme = Theme;

  get loading() {
    return this.cart.initial;
  }
}
</script>

<style lang="scss" scoped>
.order-view-layout {
  position: relative;

  .content-wrap {
    min-height: 918px;
  }

  > .content-wrap > .container {
    // map-get($space-xl, x) aka 32px for padding reserve
    $varWithoutDash: $container-width;
    $varWithoutDash2: map-get($space-xl, x);
    max-width: calc(#{$varWithoutDash} + #{$varWithoutDash2});

    .preloader {
      .ws-cary-spinner {
        min-width: 106px;
        min-height: 40px;
      }

      span {
        font-family: $ws-font-family-secondary;
        @include ws-typo-paragraph-desktop;
        text-align: center;
        font-style: normal;
        font-weight: bold;
        color: $preloader-text-color;
      }
    }
  }

  @media (max-width: $ws-breakpoint-tablet-max) {
    > .cmp-order-stepper {
      padding: 0 map-get($space-sm, x) 0 map-get($space-md, x);
    }
  }

  @media (max-width: $ws-breakpoint-mobile-max) {
    > .cmp-order-stepper {
      padding: 0 map-get($space-sm, x);
    }
  }
}
</style>
